<template>
    <div class="v-select">
        <div class="v-select__container" @click="selectClicked" :class="{ 'list-dropped': isOptionListVisible }">
            <p class="v-select__name"> {{ selected }}</p>
        </div>
        <Transition name="fade">
            <div v-show="isOptionListVisible" class="v-select__options">
                <div class="range-container">
                    <input class="range-input" type="number" :id="selectName + selectId" :name="selectName + selectId"
                        placeholder="значение от">
                    <div></div>
                    <input class="range-input" type="number" :id="selectName + selectId" :name="selectName + selectId"
                        placeholder="значение до">
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
export default {
    name: 'v-inputselect',
    props: {
        selectName: {
            type: String,
            default() {
                return 'value'
            }
        },
        selectId: {
            type: Number,
            default() {
                return 0
            }
        },
        options: {
            type: Array,
            default() {
                return []
            }
        },
        selected: {
            type: String,
            default() {
                return 'Select'
            }
        },
        selectSet: {
            type: Boolean,
            default() {
                return true
            }
        }
    },
    emits: ['select'],
    data() {
        return {
            isOptionListVisible: false,
            selectType: 'checkbox'
        }
    },

    created() {
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.isOptionListVisible = false
            }
        })

        if (this.selectSet) {
            this.selectType = 'checkbox'
        } else {
            this.selectType = 'radio'
        }
    },

    beforeUnmount() {
        window.removeEventListener("click", (e) => {
            if (!this.$el.contains(e.target)) {
                this.isOptionListVisible = false
            }
        });
    },

    methods: {
        selectClicked() {
            this.isOptionListVisible = !this.isOptionListVisible
        },
        selectOption(option) {
            this.$emit('select', option);
        },
        hideSelect() {
            this.isOptionListVisible = false;
        }
    }

}
</script>

<style lang="scss">
.v-select {
    position: relative;

    .range-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        align-items: center;
        column-gap: 15px;
        padding: 16px 16px;

        >div {
            content: "";

            width: 8px;
            height: 2px;

            background-color: $second-font-color;

            margin: 0 auto;
        }
    }

    .range-input {
        padding: 10px 10px;
        border: 1px solid $font-color;
        background-color: white;

        @extend %BODY1;
        color: $font-color;

        border-radius: 10px;

        width: 130px;

        transition: border .3s;

        &:focus {
            border-color: $main-color-hover;
        }

        &.solo-input {
            width: 100%;
        }
    }

    &__container {
        width: 150px;
        border-radius: 8px;
        padding: 8px 16px;
        text-align: left;

        position: relative;

        cursor: pointer;

        svg {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 15px;

            transition: transform .3s
        }

        &.list-dropped {
            svg {
                transform: translateY(-50%) rotate(180deg);
            }
        }
    }

    &__label {
        @extend %BODY2;
        color: $second-font-color;
    }

    &__name {
        @extend %BODY1;
        color: $font-color;
    }

    &__options {
        position: absolute;
        min-width: 150%;

        display: flex;
        flex-direction: column;

        left: 0;
        top: 40px;
        background: $white;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        padding: 8px;

        z-index: 5;

        span {
            display: flex;
            width: 100%;
            padding: 12px 16px;
            border-radius: 8px;

            transition: background-color .3s, color .3s;

            cursor: pointer;

            &:hover {
                background-color: $main-color-hover;
                color: $white;
            }
        }
    }

    &__radio-container {
        position: relative;

        input {
            position: absolute;
            z-index: -99;
            width: 1px;
            height: 1px;
            opacity: 0;
        }

        label {
            @extend %BODY1;
            color: $font-color;

            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 12px 16px;
            border-radius: 8px;

            position: relative;
            z-index: 2;

            cursor: pointer;

            transition: background-color .3s;

            white-space: nowrap;

            &:hover {
                background-color: $second-background-color;
            }
        }

        label::before {
            display: block;
            content: "";
            width: 20px;
            height: 20px;
            border: 2px solid $main-color;

            flex-shrink: 0;

            transition: background-color 0.3s, box-shadow 0.3s;

            margin-right: 15px;
        }

        input:checked+label::before {
            border: 7px solid $main-color;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-to {
    opacity: 1;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>